/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"
//import axios from '../../axios.js'

export default {
  // JWT
  loginJWT({ commit }, data) {
    return new Promise((resolve, reject) => {
      jwt.login(data.userDetails.email, data.userDetails.password)
        .then(response => {
          const accessToken = response.headers.authorization;
          localStorage.setItem('accessToken', accessToken);
          console.log(commit)
          // commit('SET_BEARER',accessToken)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


  refreshData({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.refreshData()
        .then(response => {
          // If there's user data in response
          // Update user details
          commit('UPDATE_USER_INFO', response.data, { root: true })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout({ commit }) {
    //  commit("resetState",null,{ root: true });
    commit('INIT_USER_INFO',
      null, { root: true })
   }
}
